<div class="public-bg">
	<div class="public-content">
		<div class="public-app-logo">
			<img
				src="assets/images/logo.png"
				alt="App-Logo"
				class="is-logo-white" />
		</div>

		<div class="public-center-wrapper">
			<div class="public-wrapper">
				<div>
					<h2 class="public-msg">{{ 'mfa-select.title' | translate }}</h2>
					<p>{{ 'mfa-select.subTitle' | translate }}</p>
				</div>

				@if (mfaSelectOptionsLoaded | async) {
					<div class="public-wrapper-container">
						@for (option of mfaSelectOptions; track option.UserMfa.MfaTypeName) {
							<div
								(click)="navigateToMfaPage(option)"
								class="public-wrapper-content simple-card is-action-card">
								<div class="public-wrapper-content-title">
									{{ option.MfaTypeTitle }}
								</div>
								<div
									class="public-wrapper-content-description"
									[innerHTML]="option.MfaTypeDescription"></div>
							</div>
						}
						<div class="public-footer">
							<div class="back-button">
								<eif-custom-button
									[text]="'button.back'"
									[color]="'neutral'"
									(click)="goBack()">
								</eif-custom-button>
							</div>
						</div>
					</div>
				}
			</div>
		</div>
	</div>

	<eif-copyright></eif-copyright>
</div>
